import type { RoomSettings } from './roomProtocol';

export type MatchSessionActionKind = 'leave' | 'abandon' | 'forfeit';

export interface MatchSessionActionState {
  readonly runningPlayer: boolean;
  readonly mode: RoomSettings['mode'];
  readonly forfeitAvailable: boolean;
  readonly hasVotedForfeit: boolean;
}

/** Pure policy for the single terminal action shown by the in-match menu. */
export function matchSessionActionKind(state: MatchSessionActionState): MatchSessionActionKind {
  if (!state.runningPlayer) return 'leave';
  if (state.forfeitAvailable && !state.hasVotedForfeit) return 'forfeit';
  if (state.mode === 'ranked' || state.forfeitAvailable) return 'abandon';
  return 'leave';
}
